<!--
  @AUthor Sai Naveen Somaraju
  This is the popup for the validation configuration used for 
  1) displaying the defualt configurations
  2) displaying the validated result

  it has reference for validation-configuration-form component
  @Date: 02/11/2023
-->
<div *ngIf="defualtScreen">
  <div class="mainContent">
    <div>
      <div>
        <label i18n="@@spmsUserReg" class="textColour"
          [ngStyle]="{'border-color':backgroundColorButton}">{{btnName}}</label>
        <span class="example-spacer"></span>
      </div>
    </div>
    <br>
    <button _ngcontent-qoy-c414="" (click)="retrieveDataForTable()"
      title="Show previous validation result for the current migrationid"
      class="pauseMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      style="margin-left:15px;padding:0.6rem 1.6rem 1.6rem 1.6rem;margin-top: 10px; background-color: rgb(189, 172, 66);">Validations</button>

    <button _ngcontent-qoy-c414="" (click)="addPreValidationConfiguration()"
      title="Add new Configuration to default template"
      class="pauseMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      style="margin-left:15px;padding:0.6rem 1.6rem 1.6rem 1.6rem;margin-top: 10px; background-color: rgb(189, 172, 66);">Add</button>

      <button _ngcontent-qoy-c414="" (click)="refreshAllGrids()"
      title="Add new Configuration to default template"
      class="pauseMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      style="margin-left:15px;padding:0.6rem 1.6rem 1.6rem 1.6rem;margin-top: 10px; background-color: rgb(189, 172, 66);">Refresh</button>
    <!--First GRID for General Configuartions-->


    <div [style.background-color]="backgroundColorScreen">
      <mat-expansion-panel [expanded]="true"
        style="border-radius: 0.8vh 0.8vh 0 0; box-shadow: none;margin-left: 15px; margin-right: 15px; margin-top: 2%;">
        <mat-expansion-panel-header
          style="max-height: 55px; background: rgb(228 227 230 / 41%);border: 1px solid #a9a9a9a8;">
          <mat-panel-title>
            <label style="font-size: 15px; font-weight: 100;" i18n="@@spmsUserReg" class="textColour">General
              Configurations</label>
            <span class="example-spacer"></span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div [style.background-color]="backgroundColorScreen" style="margin-left: -35px; margin-top: -50px;">
          <div>
            <mat-toolbar class="agGridtoperDiv card"
              style="background: rgb(244 243 245);border-top: 1px solid #a9a9a9a8;border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">
              <div class="insertPageNoDiv">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@Targetpageno">Page No</mat-label>
                  <input matInput type="text" (input)="onloadSearchChange($event.target.value)">
                </mat-form-field>
              </div>
              <div class="selectRecordsDiv" style="width:9.5%">
                <mat-form-field appearance="outline" style="width:100%">
                  <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                  <mat-select ngDefaultControl [(ngModel)]="loadpageSize" [ngModelOptions]="{standalone:true}"
                    (ngModelChange)="onloadPageSizeChanged(value)">
                    <mat-option value="10" selected>10</mat-option>
                    <mat-option value="200">200</mat-option>
                    <mat-option value="300">300</mat-option>
                    <mat-option value="400">400</mat-option>
                  </mat-select>

                </mat-form-field>
              </div>
              <div class="card pagination paginationFirstButton paginationFirstlastButton">
                <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onloadBtFirst()"></em>
              </div>
              <div class="card pagination paginationButtons btn-rounded">
                <ul>
                  <li class="paginationliicon">
                    <em class="fas fa-angle-left waves-effect waves-light" (click)="onloadBtPrevious()"></em>
                  </li>
                  <li>{{loadcurrentPage}}/{{loadtotalPages}}</li>
                  <li class="paginationliicon" style="padding:0;">
                    <em class="fas fa-angle-right waves-effect waves-light" (click)="onloadBtNext()"></em>
                  </li>
                </ul>
              </div>
              <div class="card pagination paginationLastButton paginationFirstlastButton">
                <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onloadBtLast()"></em>
              </div>
            </mat-toolbar>
          </div>

          <div>
            <div>
              <ag-grid-angular
                class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin"
                [columnDefs]="defaultColDef" [animateRows]="true" [pagination]="true" [rowSelection]="rowSelection"
                [gridOptions]="gridOptions" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
                [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
                [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
                [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
                (paginationChanged)="onloadPaginationChanged()" [components]="components"
                (gridReady)="retrieveInstructionsBasedOnPropertyType($event)" [hidden]="!true"></ag-grid-angular>
            </div>

          </div>
        </div>
      </mat-expansion-panel>


      <!--GRID B FOR EXTRACTION CONFIGUARTIONS-->

      <mat-expansion-panel [expanded]="true"
        style="border-radius: 0.8vh 0.8vh 0 0; box-shadow: none;margin-left: 15px; margin-right: 15px; margin-top: 2%;">
        <mat-expansion-panel-header
          style="max-height: 55px; background: rgb(228 227 230 / 41%);border: 1px solid #a9a9a9a8;">
          <mat-panel-title>
            <label style="font-size: 15px; font-weight: 100;" i18n="@@spmsUserReg" class="textColour">Extraction
              Configurations</label>
            <span class="example-spacer"></span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div [style.background-color]="backgroundColorScreen" style="margin-left: -35px; margin-top: -50px;">
          <div>
            <mat-toolbar class="agGridtoperDiv card"
              style="background: rgb(244 243 245);border-top: 1px solid #a9a9a9a8;border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">
              <div class="insertPageNoDiv">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@Targetpageno">Page No</mat-label>
                  <input matInput type="text" (input)="onloadSearchChange($event.target.value)">
                </mat-form-field>
              </div>
              <div class="selectRecordsDiv" style="width:9.5%">
                <mat-form-field appearance="outline" style="width:100%">
                  <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                  <mat-select ngDefaultControl [(ngModel)]="loadpageSize" [ngModelOptions]="{standalone:true}"
                    (ngModelChange)="onloadPageSizeChanged(value)">
                    <mat-option value="10" selected>10</mat-option>
                    <mat-option value="200">200</mat-option>
                    <mat-option value="300">300</mat-option>
                    <mat-option value="400">400</mat-option>
                  </mat-select>

                </mat-form-field>
              </div>
              <div class="card pagination paginationFirstButton paginationFirstlastButton">
                <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onloadBtFirst()"></em>
              </div>
              <div class="card pagination paginationButtons btn-rounded">
                <ul>
                  <li class="paginationliicon">
                    <em class="fas fa-angle-left waves-effect waves-light" (click)="onloadBtPrevious()"></em>
                  </li>
                  <li>{{loadcurrentPage}}/{{loadtotalPages}}</li>
                  <li class="paginationliicon" style="padding:0;">
                    <em class="fas fa-angle-right waves-effect waves-light" (click)="onloadBtNext()"></em>
                  </li>
                </ul>
              </div>
              <div class="card pagination paginationLastButton paginationFirstlastButton">
                <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onloadBtLast()"></em>
              </div>
            </mat-toolbar>
          </div>

          <div>
            <div>
              <ag-grid-angular
                class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin"
                [columnDefs]="defaultColDef" [animateRows]="true" [pagination]="true" [rowSelection]="rowSelection"
                [gridOptions]="gridOptions" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
                [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
                [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
                [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
                (paginationChanged)="onloadPaginationChanged()" [components]="components"
                (gridReady)="retrieveInstructionsExtraction($event)" [hidden]="!true"></ag-grid-angular>
            </div>

          </div>


        </div>
      </mat-expansion-panel>



      <!--GRID C FOR TRANFORMATION CONFIGURATIONS-->

      <mat-expansion-panel [expanded]="true"
        style="border-radius: 0.8vh 0.8vh 0 0; box-shadow: none;margin-left: 15px; margin-right: 15px; margin-top: 2%;">
        <mat-expansion-panel-header
          style="max-height: 55px; background: rgb(228 227 230 / 41%);border: 1px solid #a9a9a9a8;">
          <mat-panel-title>
            <label style="font-size: 15px; font-weight: 100;" i18n="@@spmsUserReg" class="textColour">Transform
              Configurations</label>
            <span class="example-spacer"></span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div [style.background-color]="backgroundColorScreen" style="margin-left: -35px; margin-top: -50px;">
          <div>
            <mat-toolbar class="agGridtoperDiv card"
              style="background: rgb(244 243 245);border-top: 1px solid #a9a9a9a8;border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">
              <div class="insertPageNoDiv">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@Targetpageno">Page No</mat-label>
                  <input matInput type="text" (input)="onloadSearchChange($event.target.value)">
                </mat-form-field>
              </div>
              <div class="selectRecordsDiv" style="width:9.5%">
                <mat-form-field appearance="outline" style="width:100%">
                  <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                  <mat-select ngDefaultControl [(ngModel)]="loadpageSize" [ngModelOptions]="{standalone:true}"
                    (ngModelChange)="onloadPageSizeChanged(value)">
                    <mat-option value="10" selected>10</mat-option>
                    <mat-option value="200">200</mat-option>
                    <mat-option value="300">300</mat-option>
                    <mat-option value="400">400</mat-option>
                  </mat-select>

                </mat-form-field>
              </div>
              <div class="card pagination paginationFirstButton paginationFirstlastButton">
                <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onloadBtFirst()"></em>
              </div>
              <div class="card pagination paginationButtons btn-rounded">
                <ul>
                  <li class="paginationliicon">
                    <em class="fas fa-angle-left waves-effect waves-light" (click)="onloadBtPrevious()"></em>
                  </li>
                  <li>{{loadcurrentPage}}/{{loadtotalPages}}</li>
                  <li class="paginationliicon" style="padding:0;">
                    <em class="fas fa-angle-right waves-effect waves-light" (click)="onloadBtNext()"></em>
                  </li>
                </ul>
              </div>
              <div class="card pagination paginationLastButton paginationFirstlastButton">
                <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onloadBtLast()"></em>
              </div>
            </mat-toolbar>
          </div>

          <div>
            <div>
              <ag-grid-angular
                class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin"
                [columnDefs]="defaultColDef" [animateRows]="true" [pagination]="true" [rowSelection]="rowSelection"
                [gridOptions]="gridOptions" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
                [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
                [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
                [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
                (paginationChanged)="onloadPaginationChanged()" [components]="components"
                (gridReady)="retrieveInstructionsForTransformation($event)" [hidden]="!true"></ag-grid-angular>
            </div>

          </div>


        </div>
      </mat-expansion-panel>


      <!--GRID D FOR LOADER CONFIGURATIONS-->

      <mat-expansion-panel [expanded]="true"
        style="border-radius: 0.8vh 0.8vh 0 0; box-shadow: none;margin-left: 15px; margin-right: 15px; margin-top: 2%;">
        <mat-expansion-panel-header
          style="max-height: 55px; background: rgb(228 227 230 / 41%);border: 1px solid #a9a9a9a8;">
          <mat-panel-title>
            <label style="font-size: 15px; font-weight: 100;" i18n="@@spmsUserReg" class="textColour">Load
              Configurations</label>
            <span class="example-spacer"></span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div [style.background-color]="backgroundColorScreen" style="margin-left: -35px; margin-top: -50px;">
          <div>
            <mat-toolbar class="agGridtoperDiv card"
              style="background: rgb(244 243 245);border-top: 1px solid #a9a9a9a8;border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">
              <div class="insertPageNoDiv">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@Targetpageno">Page No</mat-label>
                  <input matInput type="text" (input)="onloadSearchChange($event.target.value)">
                </mat-form-field>
              </div>
              <div class="selectRecordsDiv" style="width:9.5%">
                <mat-form-field appearance="outline" style="width:100%">
                  <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                  <mat-select ngDefaultControl [(ngModel)]="loadpageSize" [ngModelOptions]="{standalone:true}"
                    (ngModelChange)="onloadPageSizeChanged(value)">
                    <mat-option value="10" selected>10</mat-option>
                    <mat-option value="200">200</mat-option>
                    <mat-option value="300">300</mat-option>
                    <mat-option value="400">400</mat-option>
                  </mat-select>

                </mat-form-field>
              </div>
              <div class="card pagination paginationFirstButton paginationFirstlastButton">
                <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onloadBtFirst()"></em>
              </div>
              <div class="card pagination paginationButtons btn-rounded">
                <ul>
                  <li class="paginationliicon">
                    <em class="fas fa-angle-left waves-effect waves-light" (click)="onloadBtPrevious()"></em>
                  </li>
                  <li>{{loadcurrentPage}}/{{loadtotalPages}}</li>
                  <li class="paginationliicon" style="padding:0;">
                    <em class="fas fa-angle-right waves-effect waves-light" (click)="onloadBtNext()"></em>
                  </li>
                </ul>
              </div>
              <div class="card pagination paginationLastButton paginationFirstlastButton">
                <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onloadBtLast()"></em>
              </div>
            </mat-toolbar>
          </div>

          <div>
            <div>
              <ag-grid-angular
                class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin"
                [columnDefs]="defaultColDef" [animateRows]="true" [pagination]="true" [rowSelection]="rowSelection"
                [gridOptions]="gridOptions" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
                [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
                [paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter"
                [enableRangeSelection]="true" [debug]="true" [rowClassRules]="rowClassRules"
                (paginationChanged)="onloadPaginationChanged()" [components]="components"
                (gridReady)="retrieveInstructionsForLoad($event)" [hidden]="!true"></ag-grid-angular>
            </div>

          </div>


        </div>
      </mat-expansion-panel>

    </div>

    <!--footer we have validate and cancel buttons -->
    <mat-dialog-actions style="display: flex; justify-content: flex-end; margin-top: auto;">

      <button _ngcontent-qoy-c414="" (click)="validateProperties()" title="validate the selected properties"
        class="pauseMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        style="padding:0.6rem 1.6rem 1.5rem 1.6rem;margin-top: 20px; background-color: rgb(189, 172, 66);">{{btnName}}</button>

      <button _ngcontent-qoy-c414="" (click)="closePopUp()" title="close this popup window"
        class="pauseMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        [style.border-color]="backgroundColorButton"
        style="padding:0.5rem 1.5rem 1.5rem;margin-top: 20px;background-color: white !important;color: black;border-width: 1px;border-style: solid;">Cancel
      </button>

    </mat-dialog-actions>
  </div>
</div>

<!-------------------- Validation screen ------------------------>
<div *ngIf="validationScreen">

  <div>
    <div>
      <label i18n="@@spmsUserReg" class="textColour" [ngStyle]="{'border-color':backgroundColorButton}">Validation
        Result</label>
      <br>
      <label><b>Success Count: </b> {{successCount}} | <b>Failure Count : </b>{{failureCount}} </label>
      <span class="example-spacer"></span>
    </div>
  </div>
  <table mat-table [dataSource]="afterValidationData" class="mat-elevation-z8">

    <!-- propertyname Column -->
    <ng-container matColumnDef="propertyname">
      <th mat-header-cell *matHeaderCellDef>Property Name </th>
      <td mat-cell *matCellDef="let element"> {{element.propertyname}} </td>
    </ng-container>

    <!-- actualvalue Column -->
    <ng-container matColumnDef="actualvalue">
      <th mat-header-cell *matHeaderCellDef> Actual Value </th>
      <td mat-cell *matCellDef="let element"> {{element.actualvalue}} </td>
    </ng-container>

    <!-- expectedvalue Column -->
    <ng-container matColumnDef="expectedvalue">
      <th mat-header-cell *matHeaderCellDef> Expected Value </th>
      <td mat-cell *matCellDef="let element"> {{element.expectedvalue}} </td>
    </ng-container>

    <!-- validationstatus Column -->
    <ng-container matColumnDef="validationstatus">
      <th mat-header-cell *matHeaderCellDef> Validation Status </th>
      <td mat-cell *matCellDef="let element"> {{element.validationstatus}} </td>
    </ng-container>
    <!-- validationnote Column -->
    <ng-container matColumnDef="validationnote">
      <th mat-header-cell *matHeaderCellDef> Validation Note </th>
      <td mat-cell *matCellDef="let element"> {{element.validationnote}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      [ngClass]="{'green-row': row.validationstatus === 'true', 'red-row': row.validationstatus === 'false'}">
    </tr>
  </table>


  <mat-dialog-actions style="display: flex; justify-content: flex-end; margin-top: auto;">
    <button _ngcontent-qoy-c414="" (click)="closePopUp()" title="close this popup window"
      class="pauseMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.border-color]="backgroundColorButton"
      style="padding:0.5rem 1.5rem 1.5rem;margin-top: 20px;background-color: white !important;color: black;border-width: 1px;border-style: solid;">Cancel
    </button>
  </mat-dialog-actions>
</div>